import styled from "styled-components";

/** Page area: scrolls on its own, since the desktop layout fixes the page height (global .page). */
const Container = styled.div`
  padding: 88px 28px 110px;
  width: 100%;
  overflow-y: auto;
  background: #f4f6f9;

  .content {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 800px) {
    padding: 20px 16px 120px;
  }
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .section-title {
    font-size: 1.15rem;
    font-weight: 600;
    color: #002951;
  }

  .section-chip {
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #ffffff;
    background: #597aa7;
    padding: 3px 10px;
    border-radius: 20px;
  }

  .tiles {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 420px), 1fr));
    gap: 10px;
  }
`;

/** One parameter in a single low row: icon, title and helper on the left, its control on the right. A switch tile shows its state. */
const OptionTile = styled.div<{ $on?: boolean }>`
  background: #ffffff;
  border: 1px solid #e6eaf0;
  border-left: 3px solid ${({ $on }) => ($on ? "#002951" : "#e6eaf0")};
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0, 41, 81, 0.05);
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 14px;

  .head {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: #002951;
    background: #e8eef6;

    svg {
      font-size: 1.15rem;
    }
  }

  .label {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .label .title {
    font-size: 0.88rem;
    font-weight: 600;
    color: #1b1b1b;
    line-height: 1.25;
  }

  .label .helper {
    font-size: 0.74rem;
    color: rgb(0 0 0 / 55%);
    line-height: 1.3;
  }

  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .MuiTextField-root {
    width: 84px;
  }

  .dateInput {
    width: 150px;
  }

  .status {
    font-size: 0.72rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 20px;
    color: ${({ $on }) => ($on ? "#1d7a4c" : "#6b7280")};
    background: ${({ $on }) => ($on ? "#e5f4ec" : "#f1f3f5")};
  }

  .control {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
`;

export { Container, Section, OptionTile };
